<template>
  <div class="vForm">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VForm',
};
</script>

<style lang="scss">
.vForm {
  $root: &;
  &__form {
    &--marginTop {
      padding-top: 1.5rem;

      @include rwd('small-tablet') {
        padding-top: 0;
      }
    }
  }

  &__fieldsGroup {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
  }

  &__row {
    display: flex;
    justify-content: space-between;

    @include rwd('small-tablet') {
      flex-wrap: wrap;
    }

    > * {
      flex: 0 0 calc(50% - 1rem);

      @include rwd('small-tablet') {
        flex: 0 0 100%;
      }
    }

    #{$root}__row {
      > * {
        flex: 0 0 calc(50% - 0.5rem);

        @include rwd('small-tablet') {
          flex: 0 0 100%;
        }
      }

      &--single {
        > * {
          flex: 1;
        }
      }

      &--sameRow {
        > * {
          flex: 0 0 calc(50% - 1rem);
        }
      }
    }

    &--single {
      > * {
        flex: 1;
      }
    }

    &--wrapReversed {
      @include rwd('small-tablet') {
        flex-flow: wrap-reverse;
      }
    }

    &--block {
      display: block;
    }

    &--alignEnd {
      align-items: flex-end;
    }
  }

  &__buttonRow {
    display: flex;
    margin-top: 1.8rem;
    margin-right: -0.5rem;
    margin-left: -0.5rem;
    flex-wrap: wrap;

    &--justifyEnd {
      justify-content: flex-end;
    }

    @include rwd('small-tablet') {
      margin-top: 2.8rem;
      justify-content: center;
    }
  }

  &__button {
    margin: 0 0.5rem 1rem 0.5rem;

    &:not(#{$root}__button--single) {
      @include rwd('small-tablet') {
        flex: 1;
        padding: 0 1.5rem;
      }

      @include rwd('phone') {
        flex: 1;
      }
    }

    &--single {
      @include rwd('large-phone') {
        flex: 1;
      }
    }
  }

  &__header {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 2.3rem;
    color: $cBlack;
    margin-bottom: 2rem;
  }

  &__conditions {
    margin-left: 9rem;

    @include rwd('tablet') {
      margin-left: 4rem;
    }

    @include rwd('small-tablet') {
      margin-left: 0;
      margin-bottom: 3rem !important;
    }
  }

  &__uploader {
    margin-bottom: 2.4rem;

    @include rwd('small-tablet') {
      margin-bottom: 2.7rem;
    }
  }

  &__fileUploader {
    width: fit-content;
  }

  &__selectCode {
    height: 4.8rem;
    max-width: 8rem;
    border: 1px solid $cAddLight !important;
    margin-right: 2rem;
    margin-top: 2px;

    &:focus-within,
    &:focus,
    &:active {
      box-shadow: none !important;
    }

    & .vti__dropdown {
      width: 100%;
      padding: 0.2rem;

      &.open,
      &:hover {
        background-color: $cWhite;
      }
    }

    & .vti__selection {
      justify-content: center;
    }

    & .vti__dropdown-list {
      z-index: 20;
    }
  }

  &__selectCodeIcon {
    font-size: 7px;
    color: $cMainLight;
    margin-left: 5px;
  }

  &__selectCodeInput {
    /*display: none;*/
    width: 200px !important;
  }

  &__checkboxes {
    display: inline-block;
  }

  &__infoBar {
    margin: 0.6rem 0 3rem 0;
  }
}
</style>
